import { render } from "./WikiComponent.vue?vue&type=template&id=128a4df9&ts=true"
import script from "./WikiComponent.vue?vue&type=script&lang=ts"
export * from "./WikiComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__